export const SELECT_SERVER = '@@servers/selectServer'
export const SAVE_ENDPOINTS = '@@servers/saveEndpoints'
export const RESET_ENDPOINTS_DATA = '@@servers/resetEndpointsData'
export const SET_CURRENT_ENDPOINT = '@@servers/setCurrentEndpoint'

export const RESET_SERVERS = '@@servers/resetServers'
